import React, { useImperativeHandle, useState } from 'react'
import Avatar from '@mui/material/Avatar'
import IconButton from '@mui/material/IconButton'
import Menu from '@mui/material/Menu'

import AccountCircleOutlinedIcon from '@mui/icons-material/AccountCircleOutlined'

export type AccountMenuHandle = {
  closeMenu: () => void
}

export type AccountMenuProps = {
  /**
   * The avatar url
   */
  avatarUrl?: string
  children?: React.ReactNode
}

export const AccountMenu = React.forwardRef(function AccountMenu(props: AccountMenuProps, ref: React.Ref<AccountMenuHandle>) {
  const { avatarUrl, children } = props
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  useImperativeHandle(ref, () => ({
    closeMenu: () => {
      handleClose()
    }
  }))

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div>
      <IconButton aria-label="account menu" onClick={handleClick} sx={{ p: 0 }} data-testid="account-menu-trigger">
        {avatarUrl ? (
          <Avatar sx={{ width: 40, height: 40 }} src={avatarUrl} />
        ) : (
          <Avatar sx={{ width: 40, height: 40, background: 'radial-gradient(circle, rgba(42,182,183,1) 0%, rgba(37,154,164,1) 100%)' }}>
            <AccountCircleOutlinedIcon color="primary" />
          </Avatar>
        )}
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          elevation: 0,
          sx: {
            minWidth: 220,
            overflow: 'visible',
            filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
            mt: 1.5,
            '& .MuiAvatar-root': {
              width: 32,
              height: 32,
              ml: -0.5,
              mr: 1,
            },
            '&:before': {
              content: '""',
              display: 'block',
              position: 'absolute',
              top: 0,
              right: 14,
              width: 10,
              height: 10,
              bgcolor: 'background.paper',
              transform: 'translateY(-50%) rotate(45deg)',
              zIndex: 0,
            },
          }
        }}
      >
        {children}
      </Menu>
    </div>
  )
})

export default AccountMenu